import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';

export const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <div className="flex items-center cursor-pointer" onClick={() => scrollToSection('hero')}>
            <img 
              src="https://customer-assets.emergentagent.com/job_982f1f8b-d55b-4c68-9981-e0def6f33939/artifacts/m727ocae_IMMO%20CONCEPT-2.png" 
              alt="IMMO CONCEPT" 
              className="h-32 w-auto object-contain"
            />
            <span className={`ml-3 text-2xl font-bold transition-colors ${
              isScrolled ? 'text-[#1e5a7a]' : 'text-white'
            }`}>
              IMMO CONCEPT
            </span>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('realisations')}
              className={`text-sm font-medium transition-colors hover:text-[#f5b800] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Nos Réalisations
            </button>
            <button
              onClick={() => scrollToSection('properties')}
              className={`text-sm font-medium transition-colors hover:text-[#f5b800] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Biens à Vendre
            </button>
            <button
              onClick={() => scrollToSection('properties-abroad')}
              className={`text-sm font-medium transition-colors hover:text-[#f5b800] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Biens à l'étranger
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className={`text-sm font-medium transition-colors hover:text-[#f5b800] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className={`text-sm font-medium transition-colors hover:text-[#f5b800] ${
                isScrolled ? 'text-gray-700' : 'text-white'
              }`}
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#f5b800] hover:bg-[#d9a400] text-black font-semibold transition-all duration-300 hover:scale-105"
            >
              Prendre Rendez-vous
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button
            className="md:hidden p-2"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? (
              <X className={isScrolled ? 'text-gray-900' : 'text-white'} size={24} />
            ) : (
              <Menu className={isScrolled ? 'text-gray-900' : 'text-white'} size={24} />
            )}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="flex flex-col px-6 py-4 space-y-4">
            <button
              onClick={() => scrollToSection('realisations')}
              className="text-left text-gray-700 font-medium hover:text-[#f5b800] transition-colors"
            >
              Nos Réalisations
            </button>
            <button
              onClick={() => scrollToSection('properties')}
              className="text-left text-gray-700 font-medium hover:text-[#f5b800] transition-colors"
            >
              Biens à Vendre
            </button>
            <button
              onClick={() => scrollToSection('properties-abroad')}
              className="text-left text-gray-700 font-medium hover:text-[#f5b800] transition-colors"
            >
              Biens à l'étranger
            </button>
            <button
              onClick={() => scrollToSection('services')}
              className="text-left text-gray-700 font-medium hover:text-[#f5b800] transition-colors"
            >
              Services
            </button>
            <button
              onClick={() => scrollToSection('contact')}
              className="text-left text-gray-700 font-medium hover:text-[#f5b800] transition-colors"
            >
              Contact
            </button>
            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-[#f5b800] hover:bg-[#d9a400] text-black font-semibold w-full"
            >
              Prendre Rendez-vous
            </Button>
          </nav>
        </div>
      )}
    </header>
  );
};